import {observer} from "mobx-react";
import * as React from "react";
import ListMarketplaceUsersFeature from "./ListMarketplaceUsersFeature";
import {useNavigate} from "react-router-dom";
import {useApplication} from "../../../ApplicationProvider";
import {useNavigatorFeature} from "../../../useFeature";
import LayoutContentWrapper from "../../../components/layout/LayoutContentWrapper";
import LayoutContentToolbar from "../../../components/layout/LayoutContentToolbar";
import Table from "../../../components/table/Table";
import AddIcon from "@mui/icons-material/Add";
import FilledButton from "../../../components/buttons/FilledButton";
import {Tooltip} from "@mui/material";

function ListMarketplaceUsersScreen() {
    const application = useApplication();
    const navigator = useNavigate();
    const feature = useNavigatorFeature(() => new ListMarketplaceUsersFeature(application, navigator), navigator);

    const isFeatureReady = (feature) => {
        return feature && feature.loaded
    }


    function renderLargeText(params) {
        const maxLength = 30;
        const fullText = params.value;
        const shortenedText = fullText && fullText.length > maxLength ? `${fullText.substring(0, maxLength)}...` : fullText;

        return (
            <Tooltip title={fullText || ''} arrow>
                <div style={{
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                }}>
                    {shortenedText}
                </div>
            </Tooltip>
        );
    }

    const listUsersContent = () => {
        return (
            <div>
                <LayoutContentToolbar title="Usuarios del Marketplace">
                    <FilledButton onClick={() => feature.navigateToAddUserScreen()}>
                        <AddIcon fontSize="small"/>
                        Nuevo usuario
                    </FilledButton>
                </LayoutContentToolbar>

                <Table columns={feature.columnsContent()} rows={feature.presentedUsers()} columnsRenderer={
                    {
                        customers: (params) => renderLargeText(params),
                        deliverySites: (params) => renderLargeText(params),
                        roles: (params) => renderLargeText(params),
                    }
                } navigateToRowObjectScreen={(params) => feature.navigateToAssignRolesScreen(params.row)} />
            </div>
        )
    }

    return (
        <LayoutContentWrapper isLoading={!isFeatureReady(feature)} renderContent={() => listUsersContent()}/>
    )
}

export default observer(ListMarketplaceUsersScreen)
